module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"amazon":"Amazon","assign":"Assign review","assigned":"Assigned","edit":"Edit","open":"Open","update":"Update"}}')
  delete Component.options._Ctor
}
